/*
 * Benefits block — native <dialog> right-side drawer.
 * Document-level event delegation, so it works for any benefits-block on the
 * page and survives Shopify section re-renders. Idempotent: safe if the asset
 * is referenced more than once.
 */
(function () {
  if (window.__benefitsBlockInit) return;
  window.__benefitsBlockInit = true;

  function animatedClose(dialog) {
    dialog.classList.remove('is-active');
    /* Pause any playing video on close */
    var video = dialog.querySelector('video');
    if (video) video.pause();
    dialog.addEventListener('transitionend', function handler() {
      dialog.removeEventListener('transitionend', handler);
      dialog.close();
    });
  }

  /* Lazy-load media: swap data-src → src on first open */
  function lazyLoadMedia(dialog) {
    var els = dialog.querySelectorAll('[data-src]');
    for (var i = 0; i < els.length; i++) {
      if (!els[i].getAttribute('src')) {
        els[i].src = els[i].getAttribute('data-src');
      }
    }
    /* Tell <video> to pick up the new <source> src */
    var video = dialog.querySelector('video');
    if (video && !video._loaded) {
      video.load();
      video._loaded = true;
    }
  }

  /* Open buttons — document-level delegation (survives Shopify re-renders) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-drawer-target]');
    if (btn) {
      e.preventDefault();
      var dialog = document.getElementById(btn.getAttribute('data-drawer-target'));
      if (!dialog) return;
      dialog.showModal();
      lazyLoadMedia(dialog);
      requestAnimationFrame(function () { dialog.classList.add('is-active'); });
      return;
    }

    /* Close button */
    if (e.target.closest('[data-drawer-close]')) {
      var closeDialog = e.target.closest('.benefits-drawer');
      if (closeDialog) animatedClose(closeDialog);
      return;
    }

    /* Backdrop click — click on <dialog> itself, not its children */
    if (e.target.classList && e.target.classList.contains('benefits-drawer')) {
      animatedClose(e.target);
    }
  });

  /* Animated Escape close (override native instant close) */
  document.addEventListener('cancel', function (e) {
    if (e.target.classList && e.target.classList.contains('benefits-drawer')) {
      e.preventDefault();
      animatedClose(e.target);
    }
  });
})();
